<template>
  <div class="slider-container">
    <div class="slider">
      <div class="slider-track">
        <div v-for="(image, index) in images" :key="index" class="slide">
          <el-image :src="image" alt="Slide Image" :preview-src-list="[image]">
          </el-image>
        </div>
        <!-- 复制一份图片以实现无缝滚动 -->
        <div
          v-for="(image, index) in images"
          :key="index + images.length"
          class="slide"
        >
          <el-image :src="image" alt="Slide Image" :preview-src-list="[image]">
          </el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL } from "@/util/config";

export default {
  data() {
    return {
      images: [
        URL + "cert1.jpg",
        URL + "cert2.jpg",
        URL + "cert3.jpg",
        URL + "cert4.jpg",
        URL + "cert5.jpg",
        URL + "cert6.jpg",
      ], // 图片地址数组
    };
  },
};
</script>

<style scoped>
.slider-container {
  width: 100%;
  overflow: hidden; /* 隐藏超出部分 */
}

.slider {
  width: 100%;
  overflow: hidden;
}

.slider-track {
  display: flex;
  width: max-content; /* 宽度根据内容自适应 */
  animation: slide 20s linear infinite; /* 动画效果 */
}

.slide {
  flex: 0 0 auto;
  width: 80vw; /* 每张图片的宽度 */
}
.slide + .slide {
  margin-left: 5px;
}

img {
  width: 100%;
  height: auto;
  display: block;
}

@keyframes slide {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%); /* 移动一半的距离（复制的图片部分） */
  }
}
</style>
